import { useState, useRef } from "react";
import styles from "./FAQ.module.css";
import {FaPlus, FaMinus} from 'react-icons/fa';

// https://fusionsip.co/   https://www.fusionsip.co/

const data = [
  {
    question: "What is Fusionsip?",
    answer:
      "Fusionsip is a refreshing fruit-based beverage crafted from real fruit juices, designed to deliver a perfect balance of taste and nutrition. Enriched with a high volume of Vitamin C, it offers a revitalizing experience in every sip."
  },
  {
    question: "What fruit blends are available?",
    answer: "Fusionsip offers a curated selection of unique fruit blends, each crafted to deliver a refreshing and vibrant taste experience. Pomape brings together the rich flavors of pomegranate and grapes, while Grand-C offers a zesty fusion of grape and calamansi. Mapple provides a smooth and balanced combination of mango and apple, and Fizz-C delivers a refreshing mix of orange and peach, making each variant distinct and enjoyable."
  },
  {
    question: "Is FUSIONSIP made with real fruit juice?",
    answer: "Yes, Fusionsip is made using real fruit juices to ensure an authentic taste and natural goodness in every can."
  },
  {
    question: "Does it contain added sugar?",
    answer: "Fusionsip is crafted to maintain a delicious and balanced flavor profile. For detailed nutritional information, including sugar content, please refer to the product label on each can."
  },
  {
    question: "Is FUSIONSIP suitable for daily refreshment?",
    answer: "Absolutely. With its refreshing taste and high Vitamin C content, Fusionsip is a great choice for everyday enjoyment and hydration."
  },
  {
    question: "How should I store the drink?",
    answer: "Fusionsip should be stored in a cool, dry place. For the best taste experience, serve chilled."
  },
  {
    question: "Is FusionSip Halal certified?",
    answer: "Yes, FusionSip is Halal certified, ensuring all ingredients and production processes meet strict Halal standards."
  },
  {
    question: "Where can I buy FUSIONSIP?",
    answer: "Fusionsip is available through our official website and select retail outlets. Visit fusionsip.co to explore more and place your order."
  },
];

export default function FAQ() {
  // const [openItems, setOpenItems] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]);

  // const toggle = (index) => {
  //   if (openItems.includes(index)) {
  //     setOpenItems(openItems.filter((item) => item !== index));
  //   } else {
  //     setOpenItems([...openItems, index]);
  //   }
  // };

  const toggle = (index) => {
  if (openIndex === index) {
    setOpenIndex(null);
  } else {
    setOpenIndex(index);
  }
};

  return (
    <div className={styles.container}>
      {data.map((item, index) => {
        // const isOpen = openItems.includes(index);
        const isOpen = openIndex === index;

        return (
          <div
            key={index}
            className={`${styles.item} ${isOpen ? styles.active : ""}`}
          >
            <div
              className={styles.header}
              onClick={() => toggle(index)}
            >
              <h3>{item.question}</h3>
              <div className={styles.icon}>
                {isOpen ? <FaMinus size={10} /> : <FaPlus size={10} />}
              </div>
            </div>

            <div
              ref={(el) => (contentRefs.current[index] = el)}
              className={styles.content}
              style={{
                height: isOpen
                  ? contentRefs.current[index]?.scrollHeight + "px"
                  : "0px"
              }}
            >
              <p>{item.answer}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}